<template>
    <el-card>
      <el-alert
        title="Sem Conexão com o servidor"
        type="error"
        description="Verifique sua conexão com a internet, caso você tenha conexão, contate o administrador do sistema."
        show-icon></el-alert>
    </el-card>
</template>

<script>
    export default {
        name: "NoConnection"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/NoConnection.vue